import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config} from '../../shared';
import {Observable} from 'rxjs';
import { GenericDocContainerModel } from '../../../../../../models/aggregates/generic_doc';
import { GenericDocumentPutDTO } from '../../../data-transfer-objects';



@Injectable({
  providedIn: 'root'
})
export class TrackingIdGenericService extends BaseApiTemplateService<GenericDocContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
  Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX;
    this.httpClient = http;
  }

  
  updateWithParams(docType: string, dto: GenericDocumentPutDTO, genDocCon: any, visa: ApiVisa) {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + docType + "/with-params?generateTrackingId=" + dto.generateTrackingId + "&trackingIdPrefix=" + dto.trackingIdPrefix;
    }
    return this.httpClient.put<BasicApiResponseModel<GenericDocContainerModel>>(
      url, 
      genDocCon,
      this.getHttpHeader(visa)
    );
  }
}